module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\r\n<div class=\"prop-label\">Close Settings</div>\r\n\r\n<div class=\"row\">\r\n    <span class=\"prop-header prop-label\">After Submission</span>\r\n    <div class=\"col-md-12 prop-sublabel form-group-flex prop-separator-radio\">\r\n        <input type=\"radio\" name=\"closeOption\" value=\"default\" class=\"form-radio-group\"></input>\r\n        <label class=\"form-group-label\">Close</label>\r\n    </div>\r\n    <div class=\"col-md-12 prop-sublabel form-group-flex prop-separator-radio\">\r\n        <input type=\"radio\" name=\"closeOption\" value=\"closeBrowser\" class=\"form-radio-group\"></input>\r\n        <label class=\"form-group-label\">Close Browser Window</label>\r\n    </div>\r\n    <div class=\"col-md-12 prop-sublabel form-group-flex prop-separator-radio\">\r\n        <input type=\"radio\" name=\"closeOption\" value=\"showURL\" class=\"form-radio-group\"></input>\r\n        <label class=\"form-group-label\">Redirect to a URL</label>\r\n    </div>\r\n</div>\r\n\r\n")
  }
  return __output;

}